import {
  IsDefined,
  IsIn,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Length, Matches,
  ValidateNested
} from 'class-validator';
import { Type } from 'class-transformer';
import { BaseDto } from '../base.dto';

export class BankingCashCountSave extends BaseDto{
  @IsDefined()
  @IsInt()
  posDeviceId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsISO8601()
  day: string;

  @IsDefined()
  @IsString()
  @IsIn(['cash', 'card', 'float'])
  type: string;

  @IsDefined()
  @IsInt()
  lastModifiedEmployeeId: number;

  @IsOptional()
  @IsString()
  @Length(1, 45)
  countedWhen: string;

  @IsOptional()
  @IsInt()
  merchantServiceTimeId: number;

  @IsDefined()
  @ValidateNested({each: true})
  @Type(() => CashCount)
  cashCount: CashCount[];
}

class CashCount {
  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  value: number

  @IsDefined()
  @IsInt()
  quantity: number;

  @IsOptional()
  @IsInt()
  bags: number;

  @IsOptional()
  @Matches(/card\d+/)
  cardTerminal: string;
}
